import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { format } from "date-fns";
import { User, Bot } from "lucide-react";
import { Message as ChatMessageType } from "./types";
import React from 'react';
import DOMPurify from 'isomorphic-dompurify';

interface ChatMessageProps {
	message: ChatMessageType;
	onEntityClick?: (e: React.MouseEvent) => void;
}

export const ChatMessage = ({ message, onEntityClick }: ChatMessageProps) => {
	const isUser = message.role === "user";
	const timestamp = message.timestamp instanceof Date ? message.timestamp : new Date(message.timestamp);

	const handleClick = (e: React.MouseEvent) => {
		if (onEntityClick) {
			onEntityClick(e);
		}
	};

	return (
		<div className={`flex items-start gap-2 ${isUser ? "flex-row-reverse" : ""}`}>
			<Avatar className={`h-8 w-8 ${isUser ? "bg-blue-100" : ""}`} style={!isUser ? { backgroundColor: 'rgb(37 99 235 / var(--tw-bg-opacity, 1))' } : {}}>
				{isUser ? (
					<AvatarFallback className="text-xs">
						<User className="h-4 w-4" />
					</AvatarFallback>
				) : (
					<AvatarImage
						src="/lovable-uploads/1f16b574-2585-4f89-a895-9af7f8c1fa72.png"
						alt="Digger Assistant"
						className="object-contain h-6 w-6 mx-auto"
					/>
				)}
			</Avatar>
			<div className={`flex flex-col ${isUser ? "items-end" : "items-start"}`}>
				<div
					className={`max-w-[80%] rounded-xl p-3 shadow-md ${
						isUser
							? "bg-blue-500 text-white"
							: "bg-white/80 text-gray-900 border border-digger-blue/20 backdrop-blur-md"
					}`}
					onClick={handleClick}
				>
					<p className="text-sm">
						{Array.isArray(message.content)
							? message.content.map((part, idx) =>
								typeof part === 'string'
									? part
									: React.createElement(part.type, { key: idx, ...part.props })
							)
						: message.content}
					</p>
				</div>
				<span className="mt-1 text-xs text-gray-500">
					{format(timestamp, "HH:mm")}
				</span>
			</div>
		</div>
	);
};
